import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { AppointmentTypeModel, IAppointmentTypeModel } from '@common/models';

export class AppointmentTypeService {
  private static baseUrl: string = '/api/appointmentTypes';

  public static tags = {
    getAppointmentType: 'getAppointmentType',
    addAppointmentType: 'addAppointmentType',
    updateAppointmentType: 'updateAppointmentType',
  };

  static getAppointmentType = (
    appointmentTypeId: string,
  ): Promise<AppointmentTypeModel> =>
    trackPromise(
      new Promise<AppointmentTypeModel>((resolve, reject) => {
        http(`${this.baseUrl}/${appointmentTypeId}`)
          .get<IAppointmentTypeModel>()
          .then((json) => resolve(new AppointmentTypeModel(json)))
          .catch(reject);
      }),
      this.tags.getAppointmentType,
    );

  static addAppointmentType = (
    appointmentType: IAppointmentTypeModel,
  ): Promise<AppointmentTypeModel> =>
    trackPromise(
      new Promise<AppointmentTypeModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<IAppointmentTypeModel>(appointmentType)
          .then((json) => resolve(new AppointmentTypeModel(json)))
          .catch(reject);
      }),
      this.tags.addAppointmentType,
    );

  static updateAppointmentType = (
    appointmentType: IAppointmentTypeModel,
  ): Promise<AppointmentTypeModel> =>
    trackPromise(
      new Promise<AppointmentTypeModel>((resolve, reject) => {
        http(`${this.baseUrl}/${appointmentType.appointmentTypeId}`)
          .put<IAppointmentTypeModel>(appointmentType)
          .then((json) => resolve(new AppointmentTypeModel(json)))
          .catch(reject);
      }),
      this.tags.updateAppointmentType,
    );
}
